import styled from "styled-components";
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--chat-background);
  width: 100%;
  padding: 0 0 10px 0;
  height: 100%;

  @media (max-width: 768px) {
     height: 44vh;
  }

  .CompleteChatHeader {
    width: 100%;
    height: 100px;
    background-color: var(--dark-blue);
    color: var(--white);
    display: flex;
    align-items: center;
    position:relative;
    border: 1px solid var(--white);

    .title {
      margin: 0 auto;
      width: 100%;
      text-align: center;
      
      span {
        margin: 0 auto;
        font-size: 24px;
        font-weight: 300;
        line-height: 28px;
        font-family: roboto, sans-serif;
      }
    }

    .icon {
      cursor: pointer;
      display: flex;
      justify-content: center;
      height: 100%;
    }

    .backIcon {
      position: absolute;
      margin: 0 20px;
    }

    .auxiliarIcons {
      position: absolute;
      right: 0;
      display: flex;
      align-items: center;
      // display: none;

      div {
        padding: 10px;
        margin-right: 10px;
        border: 1px solid #fff;
        background-color: var(--blue);
        margin-left: 5px;
      }
    }

    img {
      width: 24px;
      transition: transform 0.1s ease;
      
      &:active {
        transform: scale(0.9);
      }
      
      &:hover {
        opacity: 0.8;
      }
    }
  }
  
    .arrow-icon{
      width: 15px;
    }

  .CompleteChatLoading {
    display: flex;
    color: var(--white);
    justify-content: center;
    align-items: center;
  }

  .QuestionsList {
    display: grid;
    padding: 1rem;
    gap: 1rem;
  }
  
  .QuestionItem {
    padding: 1rem;
    background-color: var(--dark-blue);
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
    cursor: pointer;

      h2 {
        justify-content: start;
        margin: 0 0 0.5rem;
        color: var(--white);
        font-size: 1.3em;
        font-weight: 300;
        line-height: 28px;
        font-family: roboto, sans-serif;
        margin-bottom: 2rem;
      }

      p {
        color: var(--white);
        font-size: 1em;
        font-weight: 300;
        line-height: 24px;
        font-family: roboto, sans-serif;
        padding: 1rem;
      }

      .description {
        max-width: 100%;
        overflow-wrap: anywhere; 
        word-break: break-word;    
      }
    }
  
  
  .QuestionTitle {
    display: flex;
    justify-content: space-between;

  }
  .ButtonsTitle{
    display: flex;
    height: 100%;
    gap: 0.5rem;

    .controls {
      display: flex;
      flex-direction: row;
      gap: 20px;
    }
  }


  .evalIcon,
  .exportIcon {
    cursor: pointer;
  }
  


  footer {
    padding: 0 2%;
    height: 3rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: auto;
  }
`;

export const Content = styled.div`
  height: 100%;
  padding: 2%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;


    @media (max-width: 768px) {
      height: 100%;
    }


  /* width */
  ::-webkit-scrollbar {
    width: 0.375rem;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 0.313rem grey;
    border-radius: 0.625rem;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: var(--scrollbar);
    border-radius: 0.625rem;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: var(--gray);
  }

  .headerContainerMessageAvatar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 0.5rem;
    color: white;
    border-radius: 0.625rem 0.625rem 0.625rem 0px;
    margin-bottom: 1.125rem;

    .sizeIcon {
      font-size: 1.5em;
      font-weight: 400;
    }
  }

  .messageAvatar {
    font-size: 0.875em;
    font-weight: 400;
    font-family: "Roboto", sans-serif;
    color: white;
  }

  .checkContainer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 4%;
  }

  .containerMenu {
    display: flex;
    flex-direction: column;
    gap: 0.313rem;
    background-color: var(--chat-background);
    margin-bottom: 0.313rem;
    height: auto;
    padding: 2%;
    border-radius: 0.625rem;
    box-shadow: 0.375rem 0.375rem 0.5rem -0.063rem rgba(0, 0, 0, 0.17);
    -webkit-box-shadow: 0.375rem 0.375rem 0.5rem -0.063rem rgba(0, 0, 0, 0.17);
    -moz-box-shadow: 0.375rem 0.375rem 0.5rem -0.063rem rgba(0, 0, 0, 0.17);
  }

  .containerMenu .sweet-loading {
    display: block;
    margin: 0 auto;
    align-Content: center;
  }

  .headerContainerMenu {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 0.625rem;
    margin-left: 0.6rem;
  }

  #menu {
    font-size: 1em;
    color: var(--white);
  }

  .subtitle {
    color: var(--clear-gray);
    font-size: 0.875em;
    margin-left: 0.6rem;
    margin-bottom: 0.2rem;
  }

  .menuLibras {
    display: flex;
    justify-content: center;
    gap: 0.625rem;
    padding: 0.23rem;

    button {
      font-size: 0.875em;
    }
  }

  .chosenOptionContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    width: 100%;
  }

  .checkIcon {
    color: #fff;
  }
`;

export const ChatContainer = styled.div`
  margin-bottom: 0.8rem;
  margin-top: 0.438rem;
  border-radius: 1.25rem 1.25rem 1.25rem 0rem;
  background-color: var(--dark-blue);
  padding: 2% 2% 3% 3%;
`;
